export var SessionMixin = {
  computed: {
    isLoggedIn() {
      return this.$store.getters['store__app__user/isLoggedIn']
    }
  }
}
